<template>
	<div id="app">
		<Header />
		<Content />
		<Footer />
	</div>
</template>

<script>
import Header from "@/components/template/header"
import Content from "@/components/template/content"
import Footer from "@/components/template/footer"
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
	name: "App",
	components: { Header, Content, Footer },
	data: function() {
		return {
			jwt: new VueEasyJwt()
		}
	},
	methods: {
		validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
			// const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
				this.$store.commit('toggleVisible', false)
                this.$router.push({ path: '/login' })
            } else {
				this.$store.commit('toggleVisible', true)
            }
        }
	},
	mounted() {
		this.validaLogin()
	},
	beforeCreate() {
		document.title = 'AsapCash | Sistema de Cobrança de Transportes'
		
	}
}
</script>

<style>
body {
	margin: 0;
}

#app {
	position: relative;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	height: 100vh;

	display: grid;

	grid-template-rows: 56px 1fr 40px;
	grid-template-columns: 1fr;
	grid-template-areas:
		"header"
		"content"
		"footer";
}

.table {
    font-size: 0.9rem;
}

.textInput, #orcamento-data_inicio, #orcamento-data_final {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.botaoGrande {
	height: 75px !important;
    font-size: 1.1rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    width: 10%;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}

</style>